import Vue from 'vue'
import { Loading } from 'element-ui'

export async function loadingData(fn) {
    let loading = Loading.service()
    try {
        await fn()
    }
    finally {
        loading.close()
    }
}

export const EventBus = new Vue()
export const getTimeZoneCity = function(){
// var timezone = jstz.determine()
//     return timezone.name()

//获取当前时区和时间
// let time = new Date();
// let timeZone = time.toLocaleTimeString('en-us',{timeZoneName:'short'});  //'1:12:38 PM GMT+8'
let timeZoneId = Intl.DateTimeFormat().resolvedOptions().timeZone; //'Asia/Shanghai'
return timeZoneId
}



// WEBPACK FOOTER //
// ./src/utils/index.js